import { DOWNLOAD_MESSAGES } from './downloadMessages';

export class DownloadError extends Error {
  readonly userMessage: string;

  constructor(userMessage: string, cause?: unknown) {
    super(userMessage);
    this.name = 'DownloadError';
    this.userMessage = userMessage;

    if (cause !== undefined) {
      this.cause = cause;
    }
  }
}

export function classifyDownloadError(error: unknown): string {
  if (error instanceof DownloadError) {
    return error.userMessage;
  }

  const message = error instanceof Error ? error.message : String(error);

  if (/browser|unsupported|createObjectURL|toBlob|toDataURL/i.test(message)) {
    return DOWNLOAD_MESSAGES.BROWSER_UNSUPPORTED;
  }

  if (/zip|JSZip|generateAsync|archive/i.test(message)) {
    return DOWNLOAD_MESSAGES.ZIP_GENERATION_FAILED;
  }

  if (/jpeg|canvas|conversion|render/i.test(message)) {
    return DOWNLOAD_MESSAGES.JPEG_CONVERSION_FAILED;
  }

  if (/no images|not available|empty/i.test(message)) {
    return DOWNLOAD_MESSAGES.NO_JPEG_AVAILABLE;
  }

  return DOWNLOAD_MESSAGES.DOWNLOAD_FAILED;
}
